import React from 'react';
import { Quote } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  role: string;
  location: string;
  age: number;
  content: string;
  imageInitials: string;
}
export function TestimonialCard({
  name,
  role,
  location,
  age,
  content,
  imageInitials
}: TestimonialCardProps) {
  return <div className="flex flex-col rounded-xl bg-white p-6 shadow-lg border border-gray-100 h-full" data-id="element-355">
      <div className="mb-4 text-blue-500" data-id="element-356">
        <Quote className="h-8 w-8 fill-current opacity-20" data-id="element-357" />
      </div>
      <p className="mb-6 flex-1 text-gray-700 italic leading-relaxed" data-id="element-358">
        "{content}"
      </p>
      <div className="flex items-center gap-4 mt-auto border-t border-gray-100 pt-4" data-id="element-359">
        <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 text-blue-700 font-bold text-lg" data-id="element-360">
          {imageInitials}
        </div>
        <div data-id="element-361">
          <h4 className="font-bold text-gray-900" data-id="element-362">{name}</h4>
          <p className="text-xs text-gray-500" data-id="element-363">{role}</p>
          <p className="text-xs text-gray-400" data-id="element-364">
            {location} • {age} años
          </p>
        </div>
      </div>
    </div>;
}